var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"grid-row"},[_c('div',{staticClass:"password-form"},[_c('ChangePasswordForm')],1)]),_c('div',{staticClass:"text-left"},[_c('button',{staticClass:"whitebutton-gemnote whitebutton-gemnote--small",on:{"click":function($event){return _vm.$store.dispatch('auth/logout')}}},[_c('span',[_vm._v("Log out")])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }